import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
export default class Slidebar {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "init") {
        this.init();
      }
    });

    this.contents = document.querySelector(".f-scrollbar");
    this.scroll = this.contents.querySelector("._scroll");
    this.scroller = this.contents.querySelector("._scroller");
    this.container = this.contents.querySelector("._container");
    this.drag = this.contents.querySelector("._drag");
    this.prev = this.contents.querySelector("._prev");
    this.next = this.contents.querySelector("._next");

    this.touchX = 0;
    this.dragLeft = 0;
    this.isDrag = false;

    this.setup();
  }

  setup() {
    this.scroll.addEventListener(
      "scroll",
      function () {
        if (!this.isDrag) {
          this.dragLeft = (this.scroll.scrollLeft / this.scroll.scrollWidth) * this.scroll.clientWidth;
          this.setPosition();
        }
      }.bind(this)
    );
    this.scroller.addEventListener(
      "touchstart",
      (event) => {
        this.isDrag = true;

        this.touchX = event.touches[0].pageX;
      },
      {
        passive: true
      }
    );
    this.scroller.addEventListener(
      "touchmove",
      (event) => {
        event.preventDefault();

        this.dragLeft += event.touches[0].pageX - this.touchX;
        this.touchX = event.touches[0].pageX;

        this.scroll.scrollLeft = (this.dragLeft / this.scroll.clientWidth) * this.scroll.scrollWidth;
        this.setPosition();
      },
      {
        passive: true
      }
    );
    this.scroller.addEventListener(
      "touchend",
      (event) => {
        this.isDrag = false;
      },
      {
        passive: true
      }
    );
    this.prev.addEventListener("click", (event) => {
      event.preventDefault();

      gsap.to(this.scroll, {
        scrollLeft: this.scroll.scrollLeft - this.scroll.clientWidth,
        duration: 0.3,
        ease: Cubic.easeOut
      });
    });
    this.next.addEventListener("click", (event) => {
      event.preventDefault();

      gsap.to(this.scroll, {
        scrollLeft: this.scroll.scrollLeft + this.scroll.clientWidth,
        duration: 0.3,
        ease: Cubic.easeOut
      });
    });
    window.addEventListener("resize", (event) => {
      this.setPosition();
    });

    this.setPosition();
  }

  setPosition() {
    if (this.scroll.clientWidth == this.scroll.scrollWidth) {
      this.scroller.classList.add("off");
    } else {
      this.scroller.classList.remove("off");

      if (this.dragLeft < 0) {
        this.dragLeft = 0;
      } else if (this.dragLeft > this.scroll.clientWidth - (this.scroll.clientWidth / this.scroll.scrollWidth) * this.scroll.clientWidth) {
        this.dragLeft = this.scroll.clientWidth - (this.scroll.clientWidth / this.scroll.scrollWidth) * this.scroll.clientWidth;
      }
      gsap.set(this.drag, { width: (this.scroll.clientWidth / this.scroll.scrollWidth) * this.scroll.clientWidth, left: this.dragLeft });
      gsap.set(this.prev, { width: this.dragLeft });
      gsap.set(this.next, { width: this.scroll.clientWidth - (this.scroll.clientWidth / this.scroll.scrollWidth) * this.scroll.clientWidth - this.dragLeft });
    }
  }

  init() {
    setTimeout(
      function () {
        this.setPosition();
      }.bind(this),
      300
    );
  }
}
